import { IconButton, useTheme } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { useThemeMode } from "./ThemeContext";

export default function ThemeToggleButton() {
  const theme = useTheme();
  const { toggleTheme } = useThemeMode();

  return (
    <IconButton
      onClick={toggleTheme}
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 3000,
        bgcolor: theme.palette.background.paper,
        boxShadow: 3,
        "&:hover": { bgcolor: theme.palette.action.hover }
      }}
    >
      {theme.palette.mode === "dark" ? (
        <LightModeIcon />
      ) : (
        <DarkModeIcon />
      )}
    </IconButton>
  );
}